module.exports = __webpack_public_path__ + "img/monterey-rectangle-side-angle.51dc46fe.png";